const CopyRight = () => {
  return (
    <div className="mx-auto flex w-full max-w-5xl items-center justify-center border-t border-slate-800 pt-5 text-center text-sm text-slate-500">
      <p className="montserrat-small">
        Forus privacy layer for shielded transfers
      </p>
    </div>
  );
};

export default CopyRight;
